module.exports = __webpack_public_path__ + "src/assets/img/bnb-capital.b491889c.png";